import Table from '../components/TableComponent';

const WeeklyPicks = () => {
    return <div>
        <Table></Table>
    </div>
  };
  
  export default WeeklyPicks